import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const MicrosoftOverviewGate = React.lazy(
  () => import("./MicrosoftOverview.gate")
);

const MicrosoftOverviewLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <MicrosoftOverviewGate />
  </React.Suspense>
);
export default () => <MicrosoftOverviewLoadable />;
